import React from 'react'
import { SalesDetails } from '../components/SalesDetails'
import { PurchaseDetails } from '../components/PurchaseDetails'
import { SummaryValidation } from '../components/SummaryValidation'
import AdvancedGSTFeatures from '../components/AdvancedGSTFeatures'

const Companies = () => {
    return (
        <div className="space-y-6">
            {/* <UnifiedClientCompany /> */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-2 space-y-6">
                    <SalesDetails />
                    <PurchaseDetails />
                </div>
                <div className="lg:col-span-1">
                    <SummaryValidation />
                </div>
            </div>
            <AdvancedGSTFeatures />
        </div>
    )
}

export default Companies
